export default "__VITE_ASSET__CA30mXTb__"